export enum ProductProblem {
  RUPTURE = 'RUPTURE',
  LOW_STOCK = 'LOW_STOCK',
  EXPIRED = 'EXPIRED',
  BREAKDOWN = 'BREAKDOWN',
}

export const productProblemsMap: Record<ProductProblem, string> = {
  EXPIRED: 'Vencimento',
  LOW_STOCK: 'Baixo estoque',
  RUPTURE: 'Ruptura',
  BREAKDOWN: 'Avaria',
}
